import * as XLSX from 'xlsx';

type AnyObject = { [key: string]: any };

const flattenJSON = (data: AnyObject, parentKey = '', result: AnyObject = {}): AnyObject => {
  for (let key in data) {
    const newKey = parentKey ? `${parentKey}.${key}` : key;
    if (Array.isArray(data[key])) {
      data[key].forEach((item : any, index : number) => {
        flattenJSON(item, `${newKey}[${index}]`, result);
      });
    } else if (typeof data[key] === 'object' && data[key] !== null) {
      flattenJSON(data[key], newKey, result);
    } else {
      result[newKey] = data[key];
    }
  }
  return result;
};

const flattenJSONForVertical = (data: AnyObject[]): AnyObject[] => {
  const rows: AnyObject[] = [];

  data.forEach((entry, index) => {
    const flattened = flattenJSON(entry);

    for (let key in flattened) {
      // Each row is a key-value pair
      rows.push({
        "Field": key,
        "Value": flattened[key]
      });
    }
  });

  return rows;
};

export const downloadExcel = (data: any): void => {
  const rows = flattenJSONForVertical(data);

  // Convert rows to a worksheet
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'VerticalData');

  // Export the workbook
  XLSX.writeFile(workbook, 'download.xlsx');
};